define('presentation/reactivation/presentationObjects/planPresentationObject',[
    'i18next',
    'constants/billingPackageTypeConstants'
], function() {
    return function() {
        const self = this;

        const _billingPackageTypes = require('constants/billingPackageTypeConstants');
        const _i18n = require('i18next');

        self.billingPackageId = ko.observable(null);
        self.packageId = ko.observable(null);
        self.type = ko.observable(0);
        self.name = ko.observable("");
        self.isSignatureService = ko.observable(false);

        self.label =  ko.pureComputed(() => {
            switch (self.type()){
                case _billingPackageTypes.telephony.id:
                    return _i18n.t('plans:labelTelephony');
                case _billingPackageTypes.liveReceptionist.id:
                    return _i18n.t('plans:labelLiveReceptionist');
                case _billingPackageTypes.webChat.id:
                    return _i18n.t('plans:labelWebChat');
                case _billingPackageTypes.outboundCalling.id:
                    return _i18n.t('plans:labelOutboundCalling');
                default:
                    return "";
            }
        });

        self.isFlexPlan = ko.pureComputed(() => {
            return self.type() === _billingPackageTypes.telephony.id;
        });
    };
});
